// extracted by mini-css-extract-plugin
module.exports = {"placeholder__text":"placeholder_placeholder__text__2dyEc","placeholder__img":"placeholder_placeholder__img__1KJpA"};